import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { SnackbarProvider } from 'notistack';
import Login from './pages/login';
import Admin from './pages/admin';
import AdminLayout from './components/layout/adminLayout';
import HomePage from './pages/homePage';
import Pattuglia from './pages/pattuglia';
import Iscrizioni from './pages/iscrizioni';
import IscrizioneForm from './pages/iscrizione/iscrizioneForm';
import TokenService from './api/tokenService';
import Contatti from './pages/contatti';
import Foto from './pages/foto';
import Regolamento from './pages/regolamento';
import LC from './pages/lc';
import ATorneo from './pages/admin/Atorneo';
import AEdizioni from './pages/admin/AEdizioni';
import AAccettazione from './pages/admin/AAccettazione'
import APartite from './pages/admin/APartite';
import StatisticheLayout from './pages/statistiche/StatisticheLayout';
import NonTrovato from './pages/statistiche/NonTrovato';
import RedirectEdizione from './pages/statistiche/RedirectEdizione';
import Hub from './pages/statistiche/Hub';
import IndiceEdizioni from './pages/statistiche/IndiceEdizioni';
import IndiceSquadre from './pages/statistiche/IndiceSquadre';
import IndiceGiocatori from './pages/statistiche/IndiceGiocatori';
import SchedaSquadra from './pages/statistiche/SchedaSquadra';
import SchedaGiocatore from './pages/statistiche/SchedaGiocatore';
import EdizioneLayout from './pages/statistiche/edizione/EdizioneLayout';
import Edizione from './pages/statistiche/edizione/Edizione';
// alias: nel dominio "Partita" è già un modello, e in questo file il nome confonderebbe
import PartitaView from './pages/statistiche/edizione/Partita';
import SquadreView from './pages/statistiche/edizione/SquadreView';
import GiocatoriView from './pages/statistiche/edizione/GiocatoriView';
import PartiteView from './pages/statistiche/edizione/PartiteView';
import AFormula from './pages/admin/AFormula';
import APlanning from './pages/admin/APlanning';
import ARisultati from './pages/admin/ARisultati';
import UnderConstruction from './pages/UnderConstruction';
import AStatistiche from './pages/admin/AStatistiche';
import AClassifiche from './pages/admin/AClassifiche';
import AFantascoutball from './pages/admin/AFantascoutball';
import AFoto from './pages/admin/AFoto';
import AGruppi from './pages/admin/AGruppi';
import ASquadreStoriche from './pages/admin/ASquadreStoriche';
import AImpostazioni from './pages/admin/AImpostazioni';
import AUtenti from './pages/admin/AUtenti';
import RefertoTablet from './components/referto/RefertoTablet';
import QRPlanning from './pages/qr/planning/QRPlanning';
import QRRisultati from './pages/qr/risultati/QRRisultati';
import RedirectFotoEdizione from './pages/qr/RedirectFotoEdizione';
import EdizioneRoute from './components/routing/EdizioneRoute';

import logo from './resources/images/logo.png'

/**
 * L'edizione a cui portano le scorciatoie /qr/*, quelle senza id dentro l'indirizzo perche' sono
 * gia' stampate sui QR code in giro. A ogni nazionale si cambia questo numero e i codici vecchi
 * ricominciano a puntare al posto giusto. Oggi: la XX.
 */
const EDIZIONE_QR = 98;

// Placeholder components for public pages
const Tornei = () => <div className="page-container"><h1>Tornei</h1></div>;
const Branche = () => <div className="page-container"><h1>Branche</h1></div>;

// Protected route component
const ProtectedRoute = ({ children }) => {
  const isAuthenticated = TokenService.hasToken() && !TokenService.isTokenExpired();
  
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }
  
  return children;
};

function App() {
  return (
    <SnackbarProvider maxSnack={3} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
      <BrowserRouter>
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<HomePage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/pattuglia" element={<Pattuglia />} />
        <Route path="/tornei" element={<Tornei />} />
        <Route path="/tornei/organizza" element={<Login />} />
        <Route path="/tornei/iscrizioni" element={<Iscrizioni />} />
        <Route path="/tornei/iscrizione/:torneoId" element={<IscrizioneForm />} />
        {/* Nuova rotta per modifica squadra esistente */}
        <Route path="/tornei/iscrizione/:torneoId/:squadraHash" element={<IscrizioneForm />} />
        {/* Rotta pubblica per modifica squadra tramite query parameter hash */}
        <Route path="/tornei/statistiche" element={<StatisticheLayout />}>
          <Route index element={<Hub />} />
          <Route path="edizioni" element={<IndiceEdizioni />} />
          <Route path="squadre" element={<IndiceSquadre />} />
          <Route path="giocatori" element={<IndiceGiocatori />} />
          <Route path="squadra/:slug" element={<SchedaSquadra />} />
          <Route path="giocatore/:idSlug" element={<SchedaGiocatore />} />
          {/* Annidate, non sorelle: gli indirizzi restano gli stessi, ma il layout scarica
              l'edizione una volta sola per tutta la permanenza su di essa. */}
          <Route path="edizione/:idEdizione" element={<EdizioneLayout />}>
            <Route index element={<Edizione />} />
            <Route path="squadre" element={<SquadreView />} />
            <Route path="giocatori" element={<GiocatoriView />} />
            <Route path="partite" element={<PartiteView />} />
            <Route path="partita/:idPartita" element={<PartitaView />} />
          </Route>
          {/* la rotta storica dei QR code: /qr/verifica ci punta ancora */}
          <Route path=":idEdizione" element={<RedirectEdizione />} />
          <Route path="*" element={<NonTrovato />} />
        </Route>
        <Route path="/branche" element={<Branche />} />
        <Route path="/branche/lc" element={<LC />} />
        <Route path="/branche/eg" element={<UnderConstruction logoUrl={logo} pageName={"Avventura"} testo={"Campetti di specialità in arrivo!"} />} />
        <Route path="/branche/rs" element={<UnderConstruction logoUrl={logo} pageName={"Servizio"} testo={"Servizio in pattuglia"} />} />
        <Route path="/regolamento" element={<Regolamento />} />
        <Route path="/foto" element={<Foto />} />
        <Route path="/foto/:idAlbum" element={<Foto />} />
        <Route path="/foto/:idAlbum/:indexPhoto" element={<Foto />} />
        <Route path="/qr/planning/:id" element={<QRPlanning />} />
        <Route path="/qr/risultati/:idEdizione" element={<QRRisultati />} />
        
        {/* Le scorciatoie stampate sui QR code: l'edizione e' EDIZIONE_QR, non un numero
            scritto qui. Le foto passano da un componente perche' l'album non e' l'edizione. */}
        <Route path="/qr/foto" element={<RedirectFotoEdizione idEdizione={EDIZIONE_QR} />} />
        <Route path="/qr/verifica" element={<Navigate to={`/tornei/statistiche/${EDIZIONE_QR}`} replace />} />
        <Route path="/qr/planning" element={<Navigate to={`/qr/planning/${EDIZIONE_QR}`} replace />} />
        <Route path="/contatti" element={<Contatti />} />
        
        {/* Admin routes with layout */}
        <Route 
          path="/admin" 
          element={
            <ProtectedRoute>
              <AdminLayout>
                <Admin />
              </AdminLayout>
            </ProtectedRoute>
          } 
        />
        <Route
          path="/admin/accettazione"
          element={
            <ProtectedRoute>
              <EdizioneRoute>
                <AdminLayout>
                  <AAccettazione />
                </AdminLayout>
              </EdizioneRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/partite"
          element={
            <ProtectedRoute>
              <EdizioneRoute>
                <AdminLayout>
                  <APartite />
                </AdminLayout>
              </EdizioneRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/partite/:id"
          element={
            <ProtectedRoute>
              <EdizioneRoute>
                <AdminLayout>
                  <APartite />
                </AdminLayout>
              </EdizioneRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/formula"
          element={
            <ProtectedRoute>
              <EdizioneRoute>
                <AdminLayout>
                  <AFormula />
                </AdminLayout>
              </EdizioneRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/planning"
          element={
            <ProtectedRoute>
              <EdizioneRoute>
                <AdminLayout>
                  <APlanning />
                </AdminLayout>
              </EdizioneRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/risultati"
          element={
            <ProtectedRoute>
              <EdizioneRoute>
                <AdminLayout>
                  <ARisultati />
                </AdminLayout>
              </EdizioneRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/statistiche"
          element={
            <ProtectedRoute>
              <EdizioneRoute>
                <AdminLayout>
                  <AStatistiche />
                </AdminLayout>
              </EdizioneRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/classifiche"
          element={
            <ProtectedRoute>
              <EdizioneRoute>
                <AdminLayout>
                  <AClassifiche />
                </AdminLayout>
              </EdizioneRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/fantascoutball"
          element={
            <ProtectedRoute>
              <EdizioneRoute>
                <AdminLayout>
                  <AFantascoutball />
                </AdminLayout>
              </EdizioneRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/foto"
          element={
            <ProtectedRoute>
              <EdizioneRoute>
                <AdminLayout>
                  <AFoto />
                </AdminLayout>
              </EdizioneRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/impostazioni"
          element={
            <ProtectedRoute>
              <EdizioneRoute>
                <AdminLayout>
                  <AImpostazioni />
                </AdminLayout>
              </EdizioneRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/utenti"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <AUtenti />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/gruppi"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <AGruppi />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/squadre-storiche"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <ASquadreStoriche />
              </AdminLayout>
            </ProtectedRoute>
          }
        />
        <Route 
          path="/admin/tornei" 
          element={
            <ProtectedRoute>
              <AdminLayout>
                <ATorneo />
              </AdminLayout>
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/admin/edizioni" 
          element={
            <ProtectedRoute>
              <AdminLayout>
                <AEdizioni />
              </AdminLayout>
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/admin/refertotablet" 
          element={<RefertoTablet />} 
        />
      </Routes>
      </BrowserRouter>
    </SnackbarProvider>
  );
}

export default App;